<template>
  <div class="az-coffie-icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="94"
      height="99"
      viewBox="0 0 94 99"
      fill="none"
    >
      <g filter="url(#filter0_d_15_1946)">
        <path
          d="M77.2477 84.5351L56.8912 89.6143H26.3565L6 84.5351V79.4558H77.2477V84.5351ZM80.8101 33.7428H72.1586V28.6636H11.0891V54.0597C11.0891 61.6785 15.1604 68.2815 21.2674 71.3291V74.3766H61.9804V71.3291C66.5606 68.7895 70.123 64.2182 71.6497 59.1389H72.1586C83.8636 59.1389 86.9171 48.9805 87.426 41.3616C87.9349 37.2983 84.8814 33.7428 80.8101 33.7428ZM72.1586 54.0597V38.822H80.8101C81.319 38.822 81.8279 39.3299 81.8279 39.3299C81.8279 39.3299 82.3369 39.8379 82.3369 40.8537C81.319 54.0597 74.1943 54.0597 72.1586 54.0597Z"
          fill="#836F6F"
        />
        <path
          d="M65.0973 3V5.64654C65.0973 8.1343 63.7105 9.38346 61.0482 11.4689L60.8457 11.6277C58.4466 13.5068 54.9745 16.2221 54.9745 21.5258V24.1724H60.0359V21.5258C60.0359 19.0381 61.4227 17.7889 64.085 15.7034L64.2875 15.5446C66.6866 13.6656 70.1587 10.9502 70.1587 5.64654V3H65.0973ZM49.9131 3V5.64654C49.9131 8.1343 48.5262 9.38346 45.864 11.4689L45.6615 11.6277C43.2624 13.5068 39.7903 16.2221 39.7903 21.5258V24.1724H44.8517V21.5258C44.8517 19.0381 46.2385 17.7889 48.9008 15.7034L49.1033 15.5446C51.5024 13.6656 54.9745 10.9502 54.9745 5.64654V3H49.9131ZM34.7289 3V5.64654C34.7289 8.1343 33.342 9.38346 30.6797 11.4689L30.4773 11.6277C28.0782 13.5068 24.6061 16.2221 24.6061 21.5258V24.1724H29.6675V21.5258C29.6675 19.0381 31.0543 17.7889 33.7166 15.7034L33.919 15.5446C36.3181 13.6656 39.7903 10.9502 39.7903 5.64654V3H34.7289Z"
          fill="#C6C3C3"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_15_1946"
          x="0"
          y="0"
          width="93.4814"
          height="98.6143"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_15_1946"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_15_1946"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  </div>
</template>
